<template>
    <section class="wrap_pop">
        <div class="popbox_wrap">
            <div class="popbox_cont">
                <p class="txt_message" v-html="text"></p>
            </div>
            <div class="popbox_btn">
                <div><button type="button" class="btn color1" @click="$emit('close')">확인</button></div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>